define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/property/Widget",
	"csi/view/RefreshController",
	"Apparel"
], function(declare,lang,Widget,RefreshController,Apparel) {

	var _RefreshController = declare(RefreshController, {
		process: function() {
			var dfd = Apparel.refreshStyleImages(this.getNode());
			if (dfd) {
				dfd.then(lang.hitch(this, this._onPublishResponse));
			} else {
				this.inherited(arguments);
			}
		}
	});

	return declare(Widget, {
		_actionControllers: {
			ViewRefresh: _RefreshController
		}
	});
});